<template>
  <div class="pane" :style="styleObj">
    <div class="title" :style="titleStyle">
      {{ title ? title : configData.name }}
    </div>
    <div class="remarks" v-if="configData.remarks && showRemarks">
      {{ configData.remarks }}
    </div>
    <slot />
    <div class="extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    bottom: {
      type: Number,
      default: 16,
    },
    title: {
      type: String,
      default: "",
    },
    titleBottom: {
      type: Number,
      default: 0,
    },
    showRemarks: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    styleObj() {
      if (typeof this.bottom === "number") {
        return { paddingBottom: this.bottom + "px" };
      } else {
        return {};
      }
    },
    titleStyle() {
      if (typeof this.titleBottom === "number") {
        return { "margin-bottom": this.titleBottom + "px" };
      } else {
        return {};
      }
    },

    ...mapGetters("auth", ["getCurrentRoute"]),
  },

  data() {
    return {
      configData: {}, // 管理员在后台配置的页面数据
    };
  },

  mounted() {
    const routeObj = this.getCurrentRoute(this.$route.path);
    if (routeObj) {
      this.configData = routeObj;
    }
  },

  watch: {
    $route: function (newRoute) {
      const routeObj = this.getCurrentRoute(newRoute.path);
      if (routeObj) {
        this.configData = routeObj;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pane {
  background-color: #fff;
  padding: 16px 32px;
  position: relative;
  .title {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.85);
  }
  .remarks {
    margin-top: 8px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.45);
  }

  .extra {
    position: absolute;
    top: 16px;
    right: 32px;
    bottom: 16px;
    display: flex;
    flex-direction: column;
  }
}
</style>